// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Float from "@rescript/core/src/Core__Float.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

function getOptionString(dict, key) {
  return Core__Option.flatMap(dict[key], Core__JSON.Decode.string);
}

function getString(dict, key, $$default) {
  return Core__Option.getOr(getOptionString(dict, key), $$default);
}

function getStringFromJson(json, $$default) {
  return Core__Option.getOr(Core__JSON.Decode.string(json), $$default);
}

function getInt(dict, key, $$default) {
  return Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.$$float), $$default) | 0;
}

function getOptionInt(dict, key) {
  return Core__Option.map(Core__Option.flatMap(dict[key], Core__JSON.Decode.$$float), (function (prim) {
                return prim | 0;
              }));
}

function getOptionFloat(dict, key) {
  return Core__Option.flatMap(dict[key], Core__JSON.Decode.$$float);
}

function getFloatFromString(str, $$default) {
  return Core__Option.getOr(Core__Float.fromString(str), $$default);
}

function getFloatFromJson(json, $$default) {
  var str = Core__JSON.Classify.classify(json);
  if (typeof str !== "object") {
    return $$default;
  }
  switch (str.TAG) {
    case "String" :
        return getFloatFromString(str._0, $$default);
    case "Number" :
        return str._0;
    default:
      return $$default;
  }
}

function getFloat(dict, key, $$default) {
  return Core__Option.getOr(Core__Option.map(dict[key], (function (json) {
                    return getFloatFromJson(json, $$default);
                  })), $$default);
}

function getJsonBoolValue(dict, key, $$default) {
  return Core__Option.getOr(dict[key], $$default);
}

function getJsonStringFromDict(dict, key, $$default) {
  return Core__Option.getOr(dict[key], $$default);
}

function getJsonArrayFromDict(dict, key, $$default) {
  return Core__Option.getOr(dict[key], $$default);
}

function getJsonFromDict(dict, key, $$default) {
  return Core__Option.getOr(dict[key], $$default);
}

function getJsonObjFromDict(dict, key, $$default) {
  return Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.object), $$default);
}

function getDecodedStringFromJson(json, callbackFunc, defaultValue) {
  return Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(Core__JSON.Decode.object(json), callbackFunc), Core__JSON.Decode.string), defaultValue);
}

function getDecodedBoolFromJson(json, callbackFunc, defaultValue) {
  return Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(Core__JSON.Decode.object(json), callbackFunc), Core__JSON.Decode.bool), defaultValue);
}

function getDictFromObj(dict, key) {
  return Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.object), {});
}

function getJsonObjectFromDict(dict, key) {
  return Core__Option.getOr(dict[key], {});
}

function getOptionBool(dict, key) {
  return Core__Option.flatMap(dict[key], Core__JSON.Decode.bool);
}

function getDictFromJson(json) {
  return Core__Option.getOr(Core__JSON.Decode.object(json), {});
}

function getDictFromDict(dict, key) {
  return getDictFromJson(getJsonObjectFromDict(dict, key));
}

function getValueAtNestedPath(_dict, _keys) {
  while(true) {
    var keys = _keys;
    var dict = _dict;
    var len = keys.length;
    if (len !== 1) {
      if (len === 0) {
        return ;
      }
      var innerDict = Core__Option.flatMap(Core__Option.flatMap(keys[0], (function(dict){
              return function (key) {
                return dict[key];
              }
              }(dict))), Core__JSON.Decode.object);
      if (innerDict === undefined) {
        return ;
      }
      _keys = keys.slice(1);
      _dict = innerDict;
      continue ;
    }
    var key = keys[0];
    return dict[key];
  };
}

function getNestedValue(dict, path) {
  return getValueAtNestedPath(dict, path.split("."));
}

function getStringAtPath(dict, path) {
  return Core__Option.flatMap(getNestedValue(dict, path), Core__JSON.Decode.string);
}

function getBool(dict, key, $$default) {
  return Core__Option.getOr(getOptionBool(dict, key), $$default);
}

function getOptionsDict(options) {
  return getDictFromJson(Core__Option.getOr(options, null));
}

function getOptionalArrayFromDict(dict, key) {
  return Core__Option.flatMap(dict[key], Core__JSON.Decode.array);
}

function getArray(dict, key) {
  return Core__Option.getOr(getOptionalArrayFromDict(dict, key), []);
}

function getStrArray(dict, key) {
  return Core__Option.getOr(getOptionalArrayFromDict(dict, key), []).map(function (json) {
              return getStringFromJson(json, "");
            });
}

function convertDictToArrayOfKeyStringTuples(dict) {
  return Object.entries(dict).map(function (entries) {
              return [
                      entries[0],
                      Core__Option.getOr(Core__JSON.Decode.string(entries[1]), "")
                    ];
            });
}

function getStringFromOptionalJson(json, $$default) {
  return Core__Option.getOr(Core__Option.flatMap(json, Core__JSON.Decode.string), $$default);
}

function snakeToPascalCase(str) {
  var words = str.split("_");
  return words.filter(function (item) {
                  return item.length > 0;
                }).map(function (item) {
                var firstChar = item.charAt(0).toUpperCase();
                var restOfString = item.length > 1 ? item.slice(1) : "";
                return firstChar + restOfString;
              }).join("");
}

function getArrayElement(arr, index, $$default) {
  return Core__Option.getOr(arr[index], $$default);
}

function mergeDict(dict1, dict2) {
  var mergedDict = Object.assign({}, dict1);
  Object.entries(dict2).forEach(function (param) {
        var value = param[1];
        var key = param[0];
        var match = mergedDict[key];
        if (match !== undefined) {
          var match$1 = Core__JSON.Decode.object(match);
          var match$2 = Core__JSON.Decode.object(value);
          if (match$1 !== undefined) {
            if (match$2 !== undefined) {
              var mergedObj = mergeDict(match$1, match$2);
              mergedDict[key] = mergedObj;
              return ;
            }
            mergedDict[key] = value;
            return ;
          }
          mergedDict[key] = value;
          return ;
        }
        mergedDict[key] = value;
      });
  return mergedDict;
}

function getDisplayName(text) {
  var transformText;
  switch (text) {
    case "afterpay_clearpay" :
        transformText = "Afterpay";
        break;
    case "bnb_smart_chain" :
        transformText = "BNB Smart Chain";
        break;
    case "classic" :
        transformText = "Cash / Voucher";
        break;
    case "credit" :
        transformText = "Card";
        break;
    case "crypto_currency" :
        transformText = "Crypto";
        break;
    case "evoucher" :
        transformText = "E-Voucher";
        break;
    case "ideal" :
        transformText = "iDEAL | Wero";
        break;
    case "open_banking" :
        transformText = "Pay By Bank";
        break;
    case "ach" :
    case "bacs" :
    case "becs" :
    case "sepa" :
        transformText = text + " Debit";
        break;
    default:
      transformText = text;
  }
  var capitalizeWord = function (str) {
    var firstChar = str[0];
    if (firstChar !== undefined) {
      return firstChar.toUpperCase() + str.slice(1);
    } else {
      return str;
    }
  };
  return transformText.split("_").map(capitalizeWord).join(" ");
}

export {
  getOptionString ,
  getString ,
  getStringFromJson ,
  getInt ,
  getOptionInt ,
  getOptionFloat ,
  getFloatFromString ,
  getFloatFromJson ,
  getFloat ,
  getJsonBoolValue ,
  getJsonStringFromDict ,
  getJsonArrayFromDict ,
  getJsonFromDict ,
  getJsonObjFromDict ,
  getDecodedStringFromJson ,
  getDecodedBoolFromJson ,
  getDictFromObj ,
  getJsonObjectFromDict ,
  getOptionBool ,
  getDictFromJson ,
  getDictFromDict ,
  getValueAtNestedPath ,
  getNestedValue ,
  getStringAtPath ,
  getBool ,
  getOptionsDict ,
  getOptionalArrayFromDict ,
  getArray ,
  getStrArray ,
  convertDictToArrayOfKeyStringTuples ,
  getStringFromOptionalJson ,
  snakeToPascalCase ,
  getArrayElement ,
  mergeDict ,
  getDisplayName ,
}
/* No side effect */
